var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"stroke":"#4A5568","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }